import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './EmailVerification.css';

const EmailVerification = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/v1/verify-email/${hash}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        const result = await response.json();

        if (response.ok) {          
          setStatus('success');
          setMessage(result.message || 'Email verified successfully!');
          
          navigate('/');
          window.location.href = "/";
          // Redirect to home after 3 seconds
          // setTimeout(() => {
          //   navigate('/');
          // }, 3000);
        } else {
          setStatus('error');
          setMessage(result.message || 'Email verification failed. Please try again.');
        }
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('error');
        setMessage('Network error. Please check your connection and try again.');
      }
    };

    if (hash) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('Invalid verification link.');
    }
  }, [hash, navigate]);

  return (
    <div className="email-verification-container">
      <div className="email-verification-card">
        {status === 'verifying' && (
          <>
            <div className="verification-icon verifying">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            <h2>Verifying Your Email</h2>
            <p>Please wait while we verify your email address...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="verification-icon success">
              <i className="fas fa-check-circle"></i>
            </div>
            <h2>Email Verified Successfully!</h2>
            <p>{message}</p>
            <p className="redirect-message">Redirecting to home page...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="verification-icon error">
              <i className="fas fa-times-circle"></i>
            </div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button 
              className="back-home-btn" 
              onClick={() => navigate('/')}
            >
              <i className="fas fa-home"></i> Back to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
